import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { Sketch } from '@ckpack/vue-color';
export default {
  components: {
    'sketch-picker': Sketch
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'rgba(51,51,51,1)'
    }
  },
  data() {
    return {
      colors: '',
      colorvalue: '',
      showSketch: false
    };
  },
  watch: {
    color(val) {
      this.commonHandle(val);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // console.log(`this.color`, this.color);
      this.commonHandle(this.color);
    });
  },
  methods: {
    okHandle() {
      if (this.colors) {
        let rgbaval = [];
        Object.keys(this.colors.rgba).forEach(child => {
          rgbaval.push(this.colors.rgba[child]);
        });
        this.colorvalue = `rgba(${rgbaval.join(',')})`;
      }
      this.showSketch = false;
      this.$emit('color', this.colors !== '' ? this.colorvalue : '');
    },
    commonHandle(val) {
      if (val) {
        let formatStr = this.color.match(/\((.+?)\)/)[1];
        let format = formatStr.split(',');
        this.colors = {
          rgba: {
            r: format[0],
            g: format[1],
            b: format[2],
            a: format[3]
          }
        };
      } else {
        this.colors = '';
      }
      this.colorvalue = this.color;
      this.okHandle();
    }
  }
};